import { Icon, Modal } from "@fluentui/react";
import HeaderCollaboratorCreate, {
  InformacionGeneral,
} from "../CollaboratorView/collaboratorCreateView";
import "./collaboratorCreate.css";
import { FieldValues, useForm } from "react-hook-form";
import TimeTaxSupportSystemClient from "../../../system";
import gererateUuid from "../../../common/uuid";
import { ProyectoEnlace } from "../CollaboratorView/createColComponents/ProyectoEnlace";
import { useState } from "react";
import OrganizationalStructure from "../CollaboratorView/createColComponents/OrganizationalStructure";
import { User } from "../../../system/User";
import { t } from "i18next";
import { EmailsSeguimiento } from "../CollaboratorView/createColComponents/EmailsSeguimiento";
import MessageCourier from "../../../lib/MessageCourier";

interface ICollaboratorcreate {
  setviewcreate: (data: number) => void;
  system: TimeTaxSupportSystemClient | undefined;
  setToastExit: (data: boolean) => void;
  user?:User;
  changeBlockUI: (state: boolean) => void;
  courier: MessageCourier
}
export interface IOrganizationNode {
  nor_id: string;
  nor_nombre: string;
  nor_nivel: string;
  nor_padre: string;
}

export interface ILisCargo {
  cargo_id: string;
  cargo_nombre: string;
  cargo_activo: string;
}

function CollaboratorCreate({
  setviewcreate,
  system,
  setToastExit,user,changeBlockUI, courier
}: ICollaboratorcreate) {
  const [toastError, setToasError] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    watch,
  } = useForm();

  const datos = async (data: FieldValues) => {
    try {
      const datos: string = gererateUuid();
      const response = await system?.createUser(data, datos);
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  const HandlerSubmit = handleSubmit(async (data: FieldValues) => {
    setToasError(false);
    courier.messageError("")
    changeBlockUI(true)
    const response = await datos(data);
    if (response?.statusCode === 200 && response.data.body) {
      await system?.getColaboradorSeguimientoSystem().upsert({
        colseg_colid: response.data.body,
        colseg_mails: data.colseg_mails
      })
      courier.messageSuccess("Colaborador creado correctamente")
      setviewcreate(0);
    }else{
      courier.messageError("No se pudo crear el colaborador. Ya existe un registro con los mismos datos")
    }

    changeBlockUI(false);
  });

  return (
    <div>
      {toastError && (
        <div className="toast_container_collaborator_error">
          <div className="toast_message_collaborator_error">
            <Icon
              iconName="ErrorBadge"
              className="icon_toast_collaborator_error"
              style={{ fontSize: "17px" }}
            />
            {t('Complete todo los campos requeridos')}
          </div>
          <Icon iconName="Clear" onClick={() =>setToasError(false)} />
        </div>
      )}
      <form onSubmit={HandlerSubmit} className="collaborator_create">
        <header className="header_collaborator_create">
          <HeaderCollaboratorCreate setviewcreate={setviewcreate} errors={errors} setToasError={setToasError} />
        </header>
        <div className="body_form">
          <div className="body_nuevo_colaborador">
            <Icon iconName="AddFriend" style={{ fontSize: "20px" }} />{" "}
            <p>{t('Nuevo colaborador:')}</p>
          </div>
          <div className="body_informacion_general">
            <InformacionGeneral
              watch={watch}
              register={register}
              errors={errors}
              setValue={setValue}
              user={user}
              system={system}
              changeBlockUI={changeBlockUI}
            />
          </div>
          <div className="body_estructura_organizacional">
            <OrganizationalStructure
              system={system}
              watch={watch}
              register={register}
              errors={errors}
              setValue={setValue}
              changeBlockUI={changeBlockUI}
            />
          </div>
          <div className="body_proyecto_enlace">
            <ProyectoEnlace
              watch={watch}
              register={register}
              errors={errors}
              setValue={setValue}
            />
          </div>
          <div className="body_proyecto_enlace">
          <EmailsSeguimiento
              watch={watch}
              register={register}
              errors={errors}
              setValue={setValue}
              control={control}
          />
          </div>
        </div>
      </form>
    </div>
  );
}

export default CollaboratorCreate;
